import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

const CTASection = () => (
  <section className="cta-section">
    <div className="cta-glow" />
    <div className="container">
      <div className="cta-inner">
        <p className="cta-label">📢 Ready to File?</p>
        <h2 className="cta-title">
          Ready to File Your Taxes &amp; Get Your{' '}
          <em>Maximum Refund?</em>
        </h2>
        <p className="cta-desc">
          Book now and get your refund started today! Fast, secure, and serving all 50 states.
        </p>
        <div className="cta-buttons">
          <Link to="/contact" className="btn btn-gold">📲 Book Appointment Now</Link>
          <a href="https://wa.me/12244154202" target="_blank" rel="noreferrer" className="btn btn-whatsapp">
            💬 Chat on WhatsApp
          </a>
          <a href="tel:+12244154202" className="btn btn-outline-white">📞 Call 224-415-4202</a>
        </div>
      </div>
    </div>
  </section>
);

export default CTASection;
